import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

let initialState = {
  list: {
    order: "",
    status: "",
    shop: "",
    date: "",
  },
};

export const transationFilterReducer = createSlice({
  name: "transationFilter",
  initialState,
  reducers: {
    updateFilter: (state, action) => {
      state.list = { ...state.list, ...action.payload };
    },
    transationFilterDestore: (state, action) => {
      state.list = initialState.list;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateFilter, transationFilterDestore } =
  transationFilterReducer.actions;

export default transationFilterReducer.reducer;
